/* ============================================================
   VELORA — theme.js
   Vanilla JS, no dependencies. All behavior is data-attribute
   driven per SPEC §3. Section agents only write markup.
   ============================================================ */
(function () {
  'use strict';

  var settings = window.veloraSettings || {};
  var routes = settings.routes || {
    cart_add: '/cart/add.js',
    cart_change: '/cart/change.js',
    cart_get: '/cart.js',
    search_suggest: '/search/suggest.json',
    predictive_search: '/search/suggest.json'
  };

  /* ---------------- Core helpers ---------------- */
  var Velora = window.Velora = window.Velora || {};

  Velora.money = function (cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var format = settings.moneyFormat || '${{amount}}';

    function defaultTo(amount, defaultValue) {
      return (amount == null || amount !== amount) ? defaultValue : amount;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollars + centsAmount;
    }

    var match = format.match(placeholderRegex);
    var placeholder = match ? match[1] : 'amount';
    switch (placeholder) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return format.replace(placeholderRegex, value);
  };

  function on(el, event, selector, handler) {
    // Delegated event helper
    el.addEventListener(event, function (e) {
      var target = e.target.closest(selector);
      if (target && el.contains(target)) handler(e, target);
    });
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function dispatch(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail || {}, bubbles: true }));
  }
  Velora.dispatch = dispatch;

  /* ---------------- Toasts ---------------- */
  var toastEl = null;
  var toastTimer = null;
  Velora.toast = function (message) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'vel-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<svg class="vel-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg><span></span>';
    toastEl.querySelector('span').textContent = message;
    requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3200);
  };

  /* ---------------- Body lock ---------------- */
  var lockCount = 0;
  function lock() { lockCount++; document.body.classList.add('vel-locked'); }
  function unlock() { lockCount = Math.max(0, lockCount - 1); if (!lockCount) document.body.classList.remove('vel-locked'); }

  /* ============================================================
     Generic drawers: data-vel-drawer="id", data-vel-drawer-open="id",
     data-vel-drawer-close (inside drawer or with target id)
     ============================================================ */
  var openDrawers = [];

  function getDrawer(id) { return document.querySelector('[data-vel-drawer="' + id + '"]'); }

  function drawerOverlay() {
    var ov = document.querySelector('.vel-drawer-overlay');
    if (!ov) {
      ov = document.createElement('div');
      ov.className = 'vel-drawer-overlay';
      ov.setAttribute('data-vel-drawer-overlay', '');
      document.body.appendChild(ov);
      ov.addEventListener('click', function () { closeAllDrawers(); });
    }
    return ov;
  }

  function openDrawer(id) {
    var drawer = getDrawer(id);
    if (!drawer || drawer.classList.contains('is-open')) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawerOverlay().classList.add('is-open');
    lock();
    openDrawers.push(id);
    dispatch('velora:drawer-open', { id: id });
  }
  Velora.openDrawer = openDrawer;

  function closeDrawer(id) {
    var drawer = getDrawer(id);
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    openDrawers = openDrawers.filter(function (d) { return d !== id; });
    if (!openDrawers.length) {
      var ov = document.querySelector('.vel-drawer-overlay');
      if (ov) ov.classList.remove('is-open');
    }
    unlock();
  }
  Velora.closeDrawer = closeDrawer;

  function closeAllDrawers() {
    openDrawers.slice().forEach(closeDrawer);
  }
  Velora.closeAllDrawers = closeAllDrawers;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-vel-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute('data-vel-drawer-open'));
      return;
    }
    var closer = e.target.closest('[data-vel-drawer-close]');
    if (closer) {
      e.preventDefault();
      var id = closer.getAttribute('data-vel-drawer-close');
      if (id) closeDrawer(id);
      else {
        var parent = closer.closest('[data-vel-drawer]');
        if (parent) closeDrawer(parent.getAttribute('data-vel-drawer'));
        else closeAllDrawers();
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAllDrawers();
      closeModal('vel-quick-view');
      closeModal(document.querySelector('[data-vel-popup]') && 'vel-newsletter-popup');
      var so = document.querySelector('.vel-search-overlay.is-open');
      if (so) closeSearchOverlay();
    }
  });

  /* ============================================================
     Modals (quick view + popup) — class based helpers
     ============================================================ */
  function openModal(id) {
    var modal = document.getElementById(id);
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    var ov = modal.previousElementSibling;
    if (ov && ov.classList.contains('vel-modal-overlay')) ov.classList.add('is-open');
    lock();
  }
  Velora.openModal = openModal;

  function closeModal(id) {
    if (!id) return;
    var modal = document.getElementById(id);
    if (!modal || !modal.classList.contains('is-open')) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    var ov = modal.previousElementSibling;
    if (ov && ov.classList.contains('vel-modal-overlay')) ov.classList.remove('is-open');
    unlock();
  }
  Velora.closeModal = closeModal;

  document.addEventListener('click', function (e) {
    if (e.target.matches('.vel-modal-overlay')) {
      var modal = e.target.nextElementSibling;
      if (modal && modal.id) closeModal(modal.id);
    }
    var mc = e.target.closest('[data-vel-modal-close]');
    if (mc) {
      var target = mc.getAttribute('data-vel-modal-close');
      if (target) closeModal(target);
      else {
        var parent = mc.closest('.vel-modal');
        if (parent) closeModal(parent.id);
      }
    }
  });

  /* ============================================================
     Sticky header: data-vel-header adds .is-scrolled after 80px
     ============================================================ */
  function initStickyHeader() {
    var header = document.querySelector('[data-vel-header]');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 80);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ============================================================
     Announcement rotation + close (session persisted)
     ============================================================ */
  function initAnnouncement() {
    var bar = document.querySelector('[data-vel-announcement]');
    if (!bar) return;
    if (sessionStorage.getItem('velora:announcement-closed') === '1') {
      bar.classList.add('is-hidden');
      return;
    }
    var messages = bar.querySelectorAll('.vel-announcement__message');
    if (messages.length > 1) {
      var idx = 0;
      messages[0].classList.add('is-active');
      setInterval(function () {
        messages[idx].classList.remove('is-active');
        idx = (idx + 1) % messages.length;
        messages[idx].classList.add('is-active');
      }, 4000);
    } else if (messages.length === 1) {
      messages[0].classList.add('is-active');
    }
    var closeBtn = bar.querySelector('[data-vel-announcement-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.classList.add('is-hidden');
        sessionStorage.setItem('velora:announcement-closed', '1');
      });
    }
  }

  /* ============================================================
     Mega menu: hover with 150ms close grace
     ============================================================ */
  function initMegaMenu() {
    document.querySelectorAll('[data-vel-mega-item]').forEach(function (item) {
      var closeTimer = null;
      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        document.querySelectorAll('[data-vel-mega-item].is-open').forEach(function (o) {
          if (o !== item) o.classList.remove('is-open');
        });
        item.classList.add('is-open');
      });
      item.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () { item.classList.remove('is-open'); }, 150);
      });
      var trigger = item.querySelector('button, a');
      if (trigger && trigger.tagName === 'BUTTON') {
        trigger.addEventListener('click', function () { item.classList.toggle('is-open'); });
      }
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) item.classList.remove('is-open');
      });
    });
  }

  /* ============================================================
     Slider: data-vel-slider with [data-slide] children
     ============================================================ */
  function initSliders() {
    document.querySelectorAll('[data-vel-slider]').forEach(function (root) {
      var track = root.querySelector('.vel-slider__track') || root;
      var slides = track.querySelectorAll('[data-slide]');
      if (!slides.length) return;
      var current = 0;
      var prevBtn = root.querySelector('[data-slider-prev]');
      var nextBtn = root.querySelector('[data-slider-next]');
      var dotsWrap = root.querySelector('[data-slider-dots]');
      var autoplay = parseInt(root.getAttribute('data-autoplay') || '0', 10);
      var timer = null;

      if (dotsWrap && slides.length > 1) {
        slides.forEach(function (_, i) {
          var dot = document.createElement('button');
          dot.className = 'vel-slider__dot';
          dot.type = 'button';
          dot.setAttribute('aria-label', 'Slide ' + (i + 1));
          dot.addEventListener('click', function () { goTo(i); resetTimer(); });
          dotsWrap.appendChild(dot);
        });
      }
      var dots = dotsWrap ? dotsWrap.querySelectorAll('.vel-slider__dot') : [];

      function goTo(i) {
        current = (i + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + current * 100 + '%)';
        dots.forEach(function (d, di) { d.classList.toggle('is-active', di === current); });
        slides.forEach(function (s, si) { s.setAttribute('aria-hidden', si === current ? 'false' : 'true'); });
      }
      function next() { goTo(current + 1); }
      function prev() { goTo(current - 1); }
      function resetTimer() {
        if (timer) clearInterval(timer);
        if (autoplay > 0 && slides.length > 1) timer = setInterval(next, autoplay);
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); resetTimer(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { next(); resetTimer(); });

      // Swipe support
      var startX = 0, dragging = false;
      track.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX; dragging = true;
      }, { passive: true });
      track.addEventListener('touchend', function (e) {
        if (!dragging) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) { dx < 0 ? next() : prev(); resetTimer(); }
        dragging = false;
      }, { passive: true });

      root.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
      root.addEventListener('mouseleave', resetTimer);

      goTo(0);
      resetTimer();
    });
  }

  /* ============================================================
     Tabs: data-vel-tabs, [data-tab-trigger="id"], [data-tab-panel="id"]
     ============================================================ */
  function initTabs() {
    document.querySelectorAll('[data-vel-tabs]').forEach(function (root) {
      var triggers = root.querySelectorAll('[data-tab-trigger]');
      var panels = root.querySelectorAll('[data-tab-panel]');
      function activate(id) {
        triggers.forEach(function (t) {
          var on = t.getAttribute('data-tab-trigger') === id;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-tab-panel') === id);
        });
      }
      triggers.forEach(function (t) {
        t.addEventListener('click', function (e) {
          e.preventDefault();
          activate(t.getAttribute('data-tab-trigger'));
        });
      });
      if (triggers.length && !root.querySelector('[data-tab-trigger].is-active')) {
        activate(triggers[0].getAttribute('data-tab-trigger'));
      }
    });
  }

  /* ============================================================
     Countdown: data-vel-countdown data-deadline="ISO"
     ============================================================ */
  function initCountdowns() {
    document.querySelectorAll('[data-vel-countdown]').forEach(function (root) {
      var deadline = new Date(root.getAttribute('data-deadline')).getTime();
      if (isNaN(deadline)) return;
      var d = root.querySelector('[data-days]');
      var h = root.querySelector('[data-hours]');
      var m = root.querySelector('[data-minutes]');
      var s = root.querySelector('[data-seconds]');
      function pad(n) { return String(n).padStart(2, '0'); }
      function tick() {
        var diff = Math.max(0, deadline - Date.now());
        var days = Math.floor(diff / 86400000);
        var hours = Math.floor(diff % 86400000 / 3600000);
        var mins = Math.floor(diff % 3600000 / 60000);
        var secs = Math.floor(diff % 60000 / 1000);
        if (d) d.textContent = pad(days);
        if (h) h.textContent = pad(hours);
        if (m) m.textContent = pad(mins);
        if (s) s.textContent = pad(secs);
        if (diff <= 0) { clearInterval(iv); dispatch('velora:countdown-ended', {}); }
      }
      var iv = setInterval(tick, 1000);
      tick();
    });
  }

  /* ============================================================
     Accordion: data-vel-accordion, [data-accordion-trigger]
     ============================================================ */
  function initAccordions() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-accordion-trigger]');
      if (!trigger) return;
      var accordion = trigger.closest('[data-vel-accordion]');
      if (!accordion) return;
      e.preventDefault();
      var panel = trigger.nextElementSibling;
      if (!panel || !panel.classList.contains('vel-accordion__panel')) {
        panel = trigger.parentElement.querySelector('.vel-accordion__panel');
      }
      if (!panel) return;
      var isOpen = trigger.classList.contains('is-open');
      if (accordion.hasAttribute('data-accordion-single')) {
        accordion.querySelectorAll('[data-accordion-trigger].is-open').forEach(function (t) {
          if (t !== trigger) {
            t.classList.remove('is-open');
            t.setAttribute('aria-expanded', 'false');
            var p = t.nextElementSibling;
            if (p && p.classList.contains('vel-accordion__panel')) p.style.maxHeight = '0px';
          }
        });
      }
      trigger.classList.toggle('is-open', !isOpen);
      trigger.setAttribute('aria-expanded', String(!isOpen));
      panel.style.maxHeight = !isOpen ? panel.scrollHeight + 'px' : '0px';
    });
  }

  /* ============================================================
     Reveal on scroll: data-vel-reveal → .is-visible
     ============================================================ */
  function initReveals() {
    var els = document.querySelectorAll('[data-vel-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -15% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
    // Footer wordmark reveal
    var wm = document.querySelector('.vel-footer__wordmark');
    if (wm) {
      var io2 = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { wm.classList.add('is-visible'); io2.disconnect(); }
        });
      }, { threshold: 0.2 });
      io2.observe(wm);
    }
  }

  /* ============================================================
     Copy: data-vel-copy (copies data-vel-copy value or input value)
     ============================================================ */
  function initCopy() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-vel-copy]');
      if (!btn) return;
      e.preventDefault();
      var text = btn.getAttribute('data-vel-copy') || '';
      var targetSel = btn.getAttribute('data-vel-copy-target');
      if (targetSel) {
        var t = document.querySelector(targetSel);
        if (t) text = t.value !== undefined ? t.value : t.textContent;
      }
      if (!text) text = window.location.href;
      function done() {
        btn.classList.add('is-copied');
        var label = btn.querySelector('[data-copy-label]');
        if (label) {
          label.dataset.original = label.dataset.original || label.textContent;
          label.textContent = settings.strings && settings.strings.copied ? settings.strings.copied : 'Copied';
        }
        setTimeout(function () {
          btn.classList.remove('is-copied');
          if (label && label.dataset.original) label.textContent = label.dataset.original;
        }, 2000);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done).catch(done);
      } else {
        var ta = document.createElement('textarea');
        ta.value = text;
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (err) {}
        document.body.removeChild(ta);
        done();
      }
    });
  }

  /* ============================================================
     Wishlist: data-vel-wishlist data-handle → localStorage
     ============================================================ */
  var WISHLIST_KEY = 'velora:wishlist';
  Velora.getWishlist = function () {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
    catch (e) { return []; }
  };
  Velora.inWishlist = function (handle) {
    return Velora.getWishlist().indexOf(handle) !== -1;
  };
  Velora.toggleWishlist = function (handle) {
    var list = Velora.getWishlist();
    var idx = list.indexOf(handle);
    if (idx === -1) list.push(handle); else list.splice(idx, 1);
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    updateWishlistUI();
    dispatch('velora:wishlist-updated', { handle: handle, list: list, added: idx === -1 });
    return idx === -1;
  };
  function updateWishlistUI() {
    var list = Velora.getWishlist();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
    document.querySelectorAll('[data-vel-wishlist]').forEach(function (el) {
      var handle = el.getAttribute('data-handle');
      var active = list.indexOf(handle) !== -1;
      el.classList.toggle('is-active', active);
      el.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }
  function initWishlist() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-vel-wishlist]');
      if (!btn) return;
      e.preventDefault();
      var handle = btn.getAttribute('data-handle');
      if (handle) Velora.toggleWishlist(handle);
    });
    updateWishlistUI();
  }

  /* ============================================================
     AJAX cart drawer — data-vel-cart-drawer
     - Intercepts form[action*="/cart/add"] → POST /cart/add.js
     - Qty steppers [data-qty-change][data-line][data-qty] → /cart/change.js
     - Removes [data-line-remove][data-line]
     - Re-renders via Section Rendering API: /?section_id=cart-drawer
     - Dispatches velora:cart-updated with the cart JSON
     ============================================================ */
  var CART_DRAWER_SECTION = 'cart-drawer';

  function cartDrawerEl() { return document.querySelector('[data-vel-cart-drawer]'); }

  function updateCartCountBubbles(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
      el.classList.remove('is-bump');
      void el.offsetWidth;
      el.classList.add('is-bump');
    });
  }

  function refreshCartDrawer(cart, openAfter) {
    var drawer = cartDrawerEl();
    updateCartCountBubbles(cart);
    dispatch('velora:cart-updated', { cart: cart });
    if (!drawer) {
      if (openAfter && settings.cartType === 'drawer') openDrawer('cart');
      return Promise.resolve(cart);
    }
    drawer.classList.add('is-loading');
    return fetch('/?section_id=' + CART_DRAWER_SECTION)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-vel-cart-drawer]') || doc.getElementById('shopify-section-' + CART_DRAWER_SECTION);
        if (fresh) {
          drawer.innerHTML = fresh.innerHTML;
        }
        drawer.classList.remove('is-loading');
        if (openAfter && settings.cartType === 'drawer') openDrawer('cart');
        return cart;
      })
      .catch(function () {
        drawer.classList.remove('is-loading');
        if (openAfter && settings.cartType === 'drawer') openDrawer('cart');
        return cart;
      });
  }
  Velora.refreshCartDrawer = refreshCartDrawer;

  function getCart() {
    return fetch(routes.cart_get).then(function (r) { return r.json(); });
  }
  Velora.getCart = getCart;

  function addToCart(form) {
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.classList.add('is-loading');
    var formData = new FormData(form);
    return fetch(routes.cart_add, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (err) { throw err; });
        }
        return r.json();
      })
      .then(function () { return getCart(); })
      .then(function (cart) {
        if (submitBtn) submitBtn.classList.remove('is-loading');
        var productTitle = formData.get('product-title') || '';
        if (settings.cartType === 'page') {
          window.location.href = '/cart';
          return cart;
        }
        refreshCartDrawer(cart, true);
        return cart;
      })
      .catch(function (err) {
        if (submitBtn) submitBtn.classList.remove('is-loading');
        Velora.toast(err && err.description ? err.description : (settings.strings && settings.strings.cartError) || 'Something went wrong. Please try again.');
        throw err;
      });
  }
  Velora.addToCart = addToCart;

  function changeCartLine(line, quantity) {
    return fetch(routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return refreshCartDrawer(cart, false); });
  }
  Velora.changeCartLine = changeCartLine;

  function initAjaxCart() {
    // Intercept every add-to-cart form (unless opted out with data-no-ajax)
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
      if (form.hasAttribute('data-no-ajax')) return;
      if (settings.cartType !== 'drawer') return; // native submit → cart page
      e.preventDefault();
      addToCart(form);
    });

    // Qty steppers + remove inside the drawer (delegated)
    document.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('[data-qty-change]');
      if (qtyBtn) {
        e.preventDefault();
        var line = parseInt(qtyBtn.getAttribute('data-line'), 10);
        var qty = parseInt(qtyBtn.getAttribute('data-qty'), 10);
        if (!isNaN(line) && !isNaN(qty)) changeCartLine(line, Math.max(0, qty));
        return;
      }
      var removeBtn = e.target.closest('[data-line-remove]');
      if (removeBtn) {
        e.preventDefault();
        var rl = parseInt(removeBtn.getAttribute('data-line'), 10);
        if (!isNaN(rl)) changeCartLine(rl, 0);
      }
    });

    // Qty input manual change
    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-qty-input]');
      if (!input) return;
      var line = parseInt(input.getAttribute('data-line'), 10);
      var qty = parseInt(input.value, 10);
      if (!isNaN(line) && !isNaN(qty)) changeCartLine(line, Math.max(0, qty));
    });

    // Generic qty steppers outside cart (e.g. PDP): [data-qty-plus]/[data-qty-minus] update sibling input
    document.addEventListener('click', function (e) {
      var plus = e.target.closest('[data-qty-plus]');
      var minus = e.target.closest('[data-qty-minus]');
      var btn = plus || minus;
      if (!btn || btn.hasAttribute('data-qty-change')) return;
      var wrap = btn.closest('.vel-qty');
      if (!wrap) return;
      var input = wrap.querySelector('input');
      if (!input) return;
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(parseInt(input.min || '1', 10), v + (plus ? 1 : -1));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // Free-shipping progress labels already render server-side; nothing else needed.
    // Prime the count bubbles on load
    if (routes.cart_get) getCart().then(function (cart) { updateCartCountBubbles(cart); }).catch(function () {});
  }

  /* ============================================================
     Quick view: data-vel-quick-view data-handle
     Fetches /products/{handle}.js, renders into #vel-quick-view
     ============================================================ */
  var qvState = { product: null, variant: null };

  function qvOptionSelections(form) {
    var selections = [];
    form.querySelectorAll('[data-qv-option]').forEach(function (group) {
      var checked = group.querySelector('input:checked');
      selections.push(checked ? checked.value : null);
    });
    return selections;
  }

  function qvFindVariant(product, selections) {
    return product.variants.find(function (v) {
      return v.options.every(function (opt, i) { return selections[i] == null || opt === selections[i]; });
    }) || null;
  }

  function qvRenderState(modal) {
    var product = qvState.product;
    var form = modal.querySelector('[data-qv-form]');
    if (!product || !form) return;
    var selections = qvOptionSelections(form);
    var variant = qvFindVariant(product, selections);
    qvState.variant = variant;

    var idInput = form.querySelector('input[name="id"]');
    var priceEl = modal.querySelector('[data-qv-price]');
    var atcBtn = form.querySelector('[data-qv-atc]');
    var featured = modal.querySelector('[data-qv-main-image]');

    if (variant) {
      if (idInput) idInput.value = variant.id;
      if (priceEl) {
        var html = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<span class="vel-price__sale">' + Velora.money(variant.price) + '</span>';
          html += '<s class="vel-price__compare">' + Velora.money(variant.compare_at_price) + '</s>';
        } else {
          html += '<span>' + Velora.money(variant.price) + '</span>';
        }
        priceEl.innerHTML = html;
      }
      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        atcBtn.querySelector('[data-qv-atc-label]').textContent = variant.available
          ? (settings.strings && settings.strings.addToCart) || 'Add to cart'
          : (settings.strings && settings.strings.soldOut) || 'Sold out';
      }
      if (variant.featured_image && featured) {
        featured.src = variant.featured_image.src;
      }
    } else {
      if (atcBtn) {
        atcBtn.disabled = true;
        atcBtn.querySelector('[data-qv-atc-label]').textContent = (settings.strings && settings.strings.unavailable) || 'Unavailable';
      }
    }
  }

  function renderQuickView(product) {
    var modal = document.getElementById('vel-quick-view');
    if (!modal) return;
    var target = modal.querySelector('[data-qv-content]');
    if (!target) return;
    qvState.product = product;

    var strings = settings.strings || {};
    var img = product.featured_image || (product.images && product.images[0]) || '';
    var thumbs = (product.images || []).slice(0, 4);

    var html = '<div class="vel-qv">';
    html += '<div class="vel-qv__gallery">';
    if (img) html += '<img class="vel-qv__main-image" data-qv-main-image src="' + img + '" alt="' + escapeHtml(product.title) + '" width="600" height="750">';
    if (thumbs.length > 1) {
      html += '<div class="vel-qv__thumbs">';
      thumbs.forEach(function (src, i) {
        html += '<button type="button" class="vel-qv__thumb' + (i === 0 ? ' is-active' : '') + '" data-qv-thumb="' + src + '"><img src="' + src + '" alt="" width="52" height="64" loading="lazy"></button>';
      });
      html += '</div>';
    }
    html += '</div>';

    html += '<div class="vel-qv__info">';
    if (product.vendor) html += '<span class="vel-qv__vendor">' + escapeHtml(product.vendor) + '</span>';
    html += '<h2 class="vel-qv__title">' + escapeHtml(product.title) + '</h2>';
    html += '<div class="vel-price vel-price--large" data-qv-price></div>';

    html += '<form method="post" action="/cart/add" data-qv-form accept-charset="UTF-8">';
    html += '<input type="hidden" name="form_type" value="product">';
    html += '<input type="hidden" name="utf8" value="✓">';
    html += '<input type="hidden" name="id" value="' + product.variants[0].id + '">';

    if (product.options && product.options.length && !(product.options.length === 1 && product.options[0] === 'Title')) {
      html += '<div class="vel-qv__variants">';
      product.options.forEach(function (optName, oi) {
        var values = [];
        product.variants.forEach(function (v) {
          if (values.indexOf(v.options[oi]) === -1) values.push(v.options[oi]);
        });
        html += '<div data-qv-option>';
        html += '<span class="vel-qv__option-name">' + escapeHtml(optName) + '</span>';
        html += '<div class="vel-qv__radios">';
        values.forEach(function (val, vi) {
          html += '<label class="vel-qv__radio">';
          html += '<input type="radio" name="qv-option-' + oi + '" value="' + escapeHtml(val) + '"' + (vi === 0 ? ' checked' : '') + '>';
          html += '<span>' + escapeHtml(val) + '</span>';
          html += '</label>';
        });
        html += '</div></div>';
      });
      html += '</div>';
    }

    html += '<div class="vel-qv__buy-row">';
    html += '<div class="vel-qty">';
    html += '<button type="button" class="vel-qty__btn" data-qty-minus aria-label="' + (strings.decreaseQty || 'Decrease quantity') + '">−</button>';
    html += '<input class="vel-qty__input" type="number" name="quantity" value="1" min="1" aria-label="' + (strings.quantity || 'Quantity') + '">';
    html += '<button type="button" class="vel-qty__btn" data-qty-plus aria-label="' + (strings.increaseQty || 'Increase quantity') + '">+</button>';
    html += '</div>';
    html += '<button type="submit" class="vel-btn vel-btn--primary" data-qv-atc><span data-qv-atc-label>' + (strings.addToCart || 'Add to cart') + '</span></button>';
    html += '</div></form>';

    html += '<div class="vel-qv__meta">';
    if (product.vendor) html += '<span><strong>' + (strings.vendor || 'Vendor') + ':</strong> ' + escapeHtml(product.vendor) + '</span>';
    if (product.type) html += '<span><strong>' + (strings.type || 'Type') + ':</strong> ' + escapeHtml(product.type) + '</span>';
    html += '</div>';

    html += '<a class="vel-qv__details-link" href="' + product.url + '">' + (strings.viewFullDetails || 'View full details') + ' <svg class="vel-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>';
    html += '</div></div>';

    target.innerHTML = html;

    // Wire interactions
    var form = target.querySelector('[data-qv-form]');
    form.addEventListener('change', function () { qvRenderState(modal); });
    target.querySelectorAll('[data-qv-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        target.querySelectorAll('[data-qv-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var main = target.querySelector('[data-qv-main-image]');
        if (main) main.src = thumb.getAttribute('data-qv-thumb');
      });
    });
    qvRenderState(modal);
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  Velora.escapeHtml = escapeHtml;

  function initQuickView() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-vel-quick-view]');
      if (!btn) return;
      e.preventDefault();
      var handle = btn.getAttribute('data-handle');
      if (!handle) return;
      var modal = document.getElementById('vel-quick-view');
      if (!modal) return;
      var target = modal.querySelector('[data-qv-content]');
      if (target) target.innerHTML = '<div style="padding:120px 32px;text-align:center;color:var(--ink-soft)">Loading…</div>';
      openModal('vel-quick-view');
      fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) {
          if (!r.ok) throw new Error('Not found');
          return r.json();
        })
        .then(renderQuickView)
        .catch(function () {
          window.location.href = '/products/' + encodeURIComponent(handle);
        });
    });
  }

  /* ============================================================
     Predictive search: [data-vel-search] input, renders into
     [data-vel-search-results]. Debounce 250ms.
     ============================================================ */
  function initPredictiveSearch() {
    document.querySelectorAll('[data-vel-search]').forEach(function (root) {
      var input = root.querySelector('input[type="search"], input[name="q"]');
      var resultsWrap = root.querySelector('[data-vel-search-results]');
      var suggestWrap = root.querySelector('[data-vel-search-suggestions]');
      if (!input || !resultsWrap) return;

      var run = debounce(function () {
        var q = input.value.trim();
        if (q.length < 2) {
          resultsWrap.innerHTML = '';
          if (suggestWrap) suggestWrap.innerHTML = '';
          return;
        }
        var url = routes.search_suggest + '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,query&resources[limit]=4&resources[options][unavailable_products]=last';
        fetch(url)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            var queries = (data.resources && data.resources.results && data.resources.results.queries) || [];
            if (suggestWrap) {
              suggestWrap.innerHTML = queries.map(function (qq) {
                return '<a class="vel-chip" href="/search?q=' + encodeURIComponent(qq.text) + '">' + escapeHtml(qq.text) + '</a>';
              }).join('');
            }
            if (!products.length) {
              resultsWrap.innerHTML = '<p class="vel-search-results__empty">No products found for “' + escapeHtml(q) + '”.</p>';
              return;
            }
            resultsWrap.innerHTML = products.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
              return '<a class="vel-search-results__item" href="' + p.url + '">' +
                (img ? '<img class="vel-search-results__thumb" src="' + img + '" alt="" width="64" height="80" loading="lazy">' : '<span class="vel-search-results__thumb"></span>') +
                '<span><span class="vel-search-results__vendor">' + escapeHtml(p.vendor || '') + '</span>' +
                '<span class="vel-search-results__title">' + escapeHtml(p.title) + '</span></span>' +
                '<span class="vel-price">' + Velora.money(p.price) + '</span>' +
                '</a>';
            }).join('') +
            '<a class="vel-btn vel-btn--secondary vel-btn--small" style="justify-self:center;margin-top:16px" href="/search?q=' + encodeURIComponent(q) + '">' +
            ((settings.strings && settings.strings.viewAllResults) || 'View all results') + '</a>';
          })
          .catch(function () { /* silent */ });
      }, 250);

      input.addEventListener('input', run);
    });
  }

  /* ============================================================
     Search overlay open/close
     ============================================================ */
  function openSearchOverlay() {
    var ov = document.querySelector('[data-vel-search-overlay]');
    if (!ov) return;
    ov.classList.add('is-open');
    ov.setAttribute('aria-hidden', 'false');
    lock();
    var input = ov.querySelector('input');
    if (input) setTimeout(function () { input.focus(); }, 300);
  }
  function closeSearchOverlay() {
    var ov = document.querySelector('[data-vel-search-overlay]');
    if (!ov || !ov.classList.contains('is-open')) return;
    ov.classList.remove('is-open');
    ov.setAttribute('aria-hidden', 'true');
    unlock();
  }
  function initSearchOverlay() {
    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-vel-search-open]');
      if (openBtn) { e.preventDefault(); openSearchOverlay(); return; }
      var closeBtn = e.target.closest('[data-vel-search-close]');
      if (closeBtn) { e.preventDefault(); closeSearchOverlay(); }
    });
  }

  /* ============================================================
     Newsletter popup: data-vel-popup — once per session,
     after 8s or 40% scroll, whichever comes first.
     ============================================================ */
  function initPopup() {
    var popup = document.querySelector('[data-vel-popup]');
    if (!popup) return;
    var id = popup.id || 'vel-newsletter-popup';
    // Just-subscribed state: open immediately, mark seen.
    if (popup.hasAttribute('data-popup-open-now')) {
      sessionStorage.setItem('velora:popup-seen', '1');
      openModal(id);
      popup.addEventListener('click', function (e) {
        if (e.target.closest('[data-vel-popup-dismiss]')) {
          e.preventDefault();
          closeModal(id);
        }
      });
      return;
    }
    if (sessionStorage.getItem('velora:popup-seen') === '1') return;

    var shown = false;
    function show() {
      if (shown) return;
      shown = true;
      sessionStorage.setItem('velora:popup-seen', '1');
      openModal(id);
    }
    var timer = setTimeout(show, 8000);
    function onScroll() {
      var scrolled = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight;
      if (scrolled >= 0.4) {
        clearTimeout(timer);
        show();
        window.removeEventListener('scroll', onScroll);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    // "No thanks" / dismiss
    popup.addEventListener('click', function (e) {
      if (e.target.closest('[data-vel-popup-dismiss]')) {
        e.preventDefault();
        closeModal(id);
      }
    });
  }

  /* ============================================================
     Marquee: data-vel-marquee — duplicates content for seamless
     loop; pause-on-hover handled by CSS. Sets --marquee-duration.
     ============================================================ */
  function initMarquees() {
    document.querySelectorAll('[data-vel-marquee]').forEach(function (root) {
      var track = root.querySelector('.vel-marquee__track');
      if (!track) return;
      if (!track.hasAttribute('data-cloned')) {
        track.innerHTML += track.innerHTML;
        track.setAttribute('data-cloned', 'true');
      }
      var speed = root.getAttribute('data-speed');
      if (speed) track.style.setProperty('--marquee-duration', speed + 's');
    });
  }

  /* ---------------- Boot ---------------- */
  function boot() {
    initStickyHeader();
    initAnnouncement();
    initMegaMenu();
    initSliders();
    initTabs();
    initCountdowns();
    initAccordions();
    initReveals();
    initCopy();
    initWishlist();
    initAjaxCart();
    initQuickView();
    initPredictiveSearch();
    initSearchOverlay();
    initPopup();
    initMarquees();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
